var modules_95586cb6 = {"container":"_1sy356x"};
import "../../../assets/D5cd7Sbc.css";

export { modules_95586cb6 as default };
//# sourceMappingURL=NumberInput.module.less.js.map
